module.exports = __webpack_public_path__ + "img/envelope.f631b0b6.svg";